import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const VerticalEllipsisIcon = (props: IconProps) => (
  <Icon w="20px" h="20px" viewBox="0 0 20 20" {...props}>
    <path d="M9.99998 6.66668C10.9166 6.66668 11.6666 5.91668 11.6666 5.00001C11.6666 4.08334 10.9166 3.33334 9.99998 3.33334C9.08331 3.33334 8.33331 4.08334 8.33331 5.00001C8.33331 5.91668 9.08331 6.66668 9.99998 6.66668ZM9.99998 8.33334C9.08331 8.33334 8.33331 9.08334 8.33331 10C8.33331 10.9167 9.08331 11.6667 9.99998 11.6667C10.9166 11.6667 11.6666 10.9167 11.6666 10C11.6666 9.08334 10.9166 8.33334 9.99998 8.33334ZM9.99998 13.3333C9.08331 13.3333 8.33331 14.0833 8.33331 15C8.33331 15.9167 9.08331 16.6667 9.99998 16.6667C10.9166 16.6667 11.6666 15.9167 11.6666 15C11.6666 14.0833 10.9166 13.3333 9.99998 13.3333Z" />
  </Icon>
);

export default memo(VerticalEllipsisIcon);
